import { t } from "../../i18n";
import { AlertTriangle, LoaderCircle, X } from "lucide-react";

export function ConfirmDangerDialog({
  title,
  description,
  confirmLabel,
  busy = false,
  onCancel,
  onConfirm,
}: {
  title: string;
  description: string;
  confirmLabel: string;
  busy?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  return (
    <div
      className="fixed inset-0 z-50 grid place-items-center bg-black/50 p-4"
      onMouseDown={(event) =>
        event.target === event.currentTarget && onCancel()
      }
    >
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="danger-title"
        aria-describedby="danger-description"
        className="w-full max-w-md rounded-2xl border border-stone-200 bg-white p-5 shadow-2xl dark:border-white/10 dark:bg-stone-900"
      >
        <div className="flex items-start gap-3">
          <div className="grid size-10 shrink-0 place-items-center rounded-xl bg-red-50 text-red-600 dark:bg-red-950/40 dark:text-red-300">
            <AlertTriangle size={19} />
          </div>
          <div className="min-w-0 flex-1">
            <h2 id="danger-title" className="font-bold">
              {title}
            </h2>
            <p
              id="danger-description"
              className="mt-1 text-sm leading-6 text-stone-500 dark:text-stone-400"
            >
              {description}
            </p>
          </div>
          <button
            type="button"
            className="button p-1.5"
            aria-label={t("Close")}
            disabled={busy}
            onClick={onCancel}
          >
            <X size={16} />
          </button>
        </div>
        <div className="mt-5 flex justify-end gap-2">
          <button
            type="button"
            className="button border border-stone-200 dark:border-white/10"
            disabled={busy}
            onClick={onCancel}
          >
            {t("Cancel")}
          </button>
          <button
            type="button"
            className="button bg-red-600 text-white hover:bg-red-700"
            disabled={busy}
            onClick={onConfirm}
          >
            {busy && <LoaderCircle className="animate-spin" size={15} />}{" "}
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
